export default [
    {
        path: '',
        name: 'pageKomisaris',
        component: () => import('./page-komisaris')
    }
]